<script setup lang="ts">
import { computed } from 'vue';
import { useUserStore } from '@/stores';

const userStore = useUserStore();

// The ? icon goes directly to the role-appropriate help destination — no dropdown,
// since the Support page itself surfaces the user guide as one of its three cards.
// Super admins don't have a Support page (they answer the calls), so they're sent
// to their guide root instead.
const helpRoute = computed(() => {
  switch (userStore.profile?.role) {
    case 'org_admin':
      return '/admin/support';
    case 'super_admin':
      return '/super-admin/guide/organizations';
    default:
      return '/support';
  }
});
</script>

<template>
  <RouterLink :to="helpRoute" class="icon-btn help-icon" aria-label="Help">
    <bb-icon name="help" decorative></bb-icon>
  </RouterLink>
</template>
